module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei6.svg";